import { colors } from "@hubrise/react-components"
import styled from "styled-components"

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
`

export const OptionLabel = styled.div``

export const OptionValue = styled.div`
  font-style: italic;
`

export const SectionDivider = styled.div`
  border-top: 1px solid ${colors.borderLight};
  margin: 1rem 0;
`
